import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

// The agent Home "Today" tile: ONE call, POST /api/agent-cases/today. The types come from the data (documents received today by type, discrepancies new today by type), so a type the
// engine starts to write appears by itself. If the call fails the tile says so; it never shows a made-up 0.
//   loading   waiting     ready   { today, received: [{ type, count }], unclassified, discrepancies: [{ type, count }] }     error   could not be read
export function useToday(orgId) {
  const [state, setState] = useState({ status: 'loading', data: null, orgId });
  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', data: null, orgId });
    (async () => {
      try {
        const res = await apiFetch('/api/agent-cases/today', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' });
        const json = await res.json();
        if (!res.ok || !json || !json.ok || !Array.isArray(json.received) || !Array.isArray(json.discrepancies)) throw new Error('today');
        if (!cancelled) setState({ status: 'ready', data: json, orgId });
      } catch {
        if (!cancelled) setState({ status: 'error', data: null, orgId });
      }
    })();
    return () => { cancelled = true; };
  }, [orgId]);
  return state.orgId === orgId ? state : { status: 'loading', data: null, orgId };
}
